export const SUPER_ADMIN_ROLE = 1;
export const SUPER_TENANT = "SuperTenant";
export const ROLES = {
  SUPER_ADMIN: "Super Admin",
  ADMIN: "Admin",
  EXECUTIVE: "Executive",
  SALES_MANAGER: "Sales Manager",
  USER: "User",
};

export const COUNTRY_CODES = [
  { dialCode: "+93", name: "Afghanistan", iso2: "af" },
  { dialCode: "+355", name: "Albania", iso2: "al" },
  { dialCode: "+213", name: "Algeria", iso2: "dz" },
  { dialCode: "+376", name: "Andorra", iso2: "ad" },
  { dialCode: "+244", name: "Angola", iso2: "ao" },
  { dialCode: "+1268", name: "Antigua and Barbuda", iso2: "ag" },
  { dialCode: "+54", name: "Argentina", iso2: "ar" },
  { dialCode: "+374", name: "Armenia", iso2: "am" },
  { dialCode: "+297", name: "Aruba", iso2: "aw" },
  { dialCode: "+61", name: "Australia", iso2: "au" },
  { dialCode: "+43", name: "Austria", iso2: "at" },
  { dialCode: "+994", name: "Azerbaijan", iso2: "az" },
  { dialCode: "+1242", name: "Bahamas", iso2: "bs" },
  { dialCode: "+973", name: "Bahrain", iso2: "bh" },
  { dialCode: "+880", name: "Bangladesh", iso2: "bd" },
  { dialCode: "+1246", name: "Barbados", iso2: "bb" },
  { dialCode: "+375", name: "Belarus", iso2: "by" },
  { dialCode: "+32", name: "Belgium", iso2: "be" },
  { dialCode: "+501", name: "Belize", iso2: "bz" },
  { dialCode: "+229", name: "Benin", iso2: "bj" },
  { dialCode: "+975", name: "Bhutan", iso2: "bt" },
  { dialCode: "+591", name: "Bolivia", iso2: "bo" },
  { dialCode: "+387", name: "Bosnia and Herzegovina", iso2: "ba" },
  { dialCode: "+267", name: "Botswana", iso2: "bw" },
  { dialCode: "+55", name: "Brazil", iso2: "br" },
  { dialCode: "+246", name: "British Indian Ocean Territory", iso2: "io" },
  { dialCode: "+673", name: "Brunei", iso2: "bn" },
  { dialCode: "+359", name: "Bulgaria", iso2: "bg" },
  { dialCode: "+226", name: "Burkina Faso", iso2: "bf" },
  { dialCode: "+257", name: "Burundi", iso2: "bi" },
  { dialCode: "+855", name: "Cambodia", iso2: "kh" },
  { dialCode: "+237", name: "Cameroon", iso2: "cm" },
  { dialCode: "+1", name: "Canada", iso2: "ca" },
  { dialCode: "+238", name: "Cape Verde", iso2: "cv" },
  { dialCode: "+599", name: "Caribbean Netherlands", iso2: "bq" },
  { dialCode: "+236", name: "Central African Republic", iso2: "cf" },
  { dialCode: "+235", name: "Chad", iso2: "td" },
  { dialCode: "+56", name: "Chile", iso2: "cl" },
  { dialCode: "+86", name: "China", iso2: "cn" },
  { dialCode: "+57", name: "Colombia", iso2: "co" },
  { dialCode: "+269", name: "Comoros", iso2: "km" },
  { dialCode: "+243", name: "Congo", iso2: "cd" },
  { dialCode: "+242", name: "Congo", iso2: "cg" },
  { dialCode: "+506", name: "Costa Rica", iso2: "cr" },
  { dialCode: "+225", name: "Côte d’Ivoire", iso2: "ci" },
  { dialCode: "+385", name: "Croatia", iso2: "hr" },
  { dialCode: "+53", name: "Cuba", iso2: "cu" },
  { dialCode: "+599", name: "Curaçao", iso2: "cw" },
  { dialCode: "+357", name: "Cyprus", iso2: "cy" },
  { dialCode: "+420", name: "Czech Republic", iso2: "cz" },
  { dialCode: "+45", name: "Denmark", iso2: "dk" },
  { dialCode: "+253", name: "Djibouti", iso2: "dj" },
  { dialCode: "+1767", name: "Dominica", iso2: "dm" },
  { dialCode: "+1", name: "Dominican Republic", iso2: "do" },
  { dialCode: "+593", name: "Ecuador", iso2: "ec" },
  { dialCode: "+20", name: "Egypt", iso2: "eg" },
  { dialCode: "+503", name: "El Salvador", iso2: "sv" },
  { dialCode: "+240", name: "Equatorial Guinea", iso2: "gq" },
  { dialCode: "+291", name: "Eritrea", iso2: "er" },
  { dialCode: "+372", name: "Estonia", iso2: "ee" },
  { dialCode: "+251", name: "Ethiopia", iso2: "et" },
  { dialCode: "+679", name: "Fiji", iso2: "fj" },
  { dialCode: "+358", name: "Finland", iso2: "fi" },
  { dialCode: "+33", name: "France", iso2: "fr" },
  { dialCode: "+594", name: "French Guiana", iso2: "gf" },
  { dialCode: "+689", name: "French Polynesia", iso2: "pf" },
  { dialCode: "+241", name: "Gabon", iso2: "ga" },
  { dialCode: "+220", name: "Gambia", iso2: "gm" },
  { dialCode: "+995", name: "Georgia", iso2: "ge" },
  { dialCode: "+49", name: "Germany", iso2: "de" },
  { dialCode: "+233", name: "Ghana", iso2: "gh" },
  { dialCode: "+30", name: "Greece", iso2: "gr" },
  { dialCode: "+1473", name: "Grenada", iso2: "gd" },
  { dialCode: "+590", name: "Guadeloupe", iso2: "gp" },
  { dialCode: "+1671", name: "Guam", iso2: "gu" },
  { dialCode: "+502", name: "Guatemala", iso2: "gt" },
  { dialCode: "+224", name: "Guinea", iso2: "gn" },
  { dialCode: "+245", name: "Guinea-Bissau", iso2: "gw" },
  { dialCode: "+592", name: "Guyana", iso2: "gy" },
  { dialCode: "+509", name: "Haiti", iso2: "ht" },
  { dialCode: "+504", name: "Honduras", iso2: "hn" },
  { dialCode: "+852", name: "Hong Kong", iso2: "hk" },
  { dialCode: "+36", name: "Hungary", iso2: "hu" },
  { dialCode: "+354", name: "Iceland", iso2: "is" },
  { dialCode: "+91", name: "India", iso2: "in" },
  { dialCode: "+62", name: "Indonesia", iso2: "id" },
  { dialCode: "+98", name: "Iran", iso2: "ir" },
  { dialCode: "+964", name: "Iraq", iso2: "iq" },
  { dialCode: "+353", name: "Ireland", iso2: "ie" },
  { dialCode: "+972", name: "Israel", iso2: "il" },
  { dialCode: "+39", name: "Italy", iso2: "it" },
  { dialCode: "+1876", name: "Jamaica", iso2: "jm" },
  { dialCode: "+81", name: "Japan", iso2: "jp" },
  { dialCode: "+962", name: "Jordan", iso2: "jo" },
  { dialCode: "+7", name: "Kazakhstan", iso2: "kz" },
  { dialCode: "+254", name: "Kenya", iso2: "ke" },
  { dialCode: "+686", name: "Kiribati", iso2: "ki" },
  { dialCode: "+383", name: "Kosovo", iso2: "xk" },
  { dialCode: "+965", name: "Kuwait", iso2: "kw" },
  { dialCode: "+996", name: "Kyrgyzstan", iso2: "kg" },
  { dialCode: "+856", name: "Laos", iso2: "la" },
  { dialCode: "+371", name: "Latvia", iso2: "lv" },
  { dialCode: "+961", name: "Lebanon", iso2: "lb" },
  { dialCode: "+266", name: "Lesotho", iso2: "ls" },
  { dialCode: "+231", name: "Liberia", iso2: "lr" },
  { dialCode: "+218", name: "Libya", iso2: "ly" },
  { dialCode: "+423", name: "Liechtenstein", iso2: "li" },
  { dialCode: "+370", name: "Lithuania", iso2: "lt" },
  { dialCode: "+352", name: "Luxembourg", iso2: "lu" },
  { dialCode: "+853", name: "Macau", iso2: "mo" },
  { dialCode: "+389", name: "Macedonia", iso2: "mk" },
  { dialCode: "+261", name: "Madagascar", iso2: "mg" },
  { dialCode: "+265", name: "Malawi", iso2: "mw" },
  { dialCode: "+60", name: "Malaysia", iso2: "my" },
  { dialCode: "+960", name: "Maldives", iso2: "mv" },
  { dialCode: "+223", name: "Mali", iso2: "ml" },
  { dialCode: "+356", name: "Malta", iso2: "mt" },
  { dialCode: "+692", name: "Marshall Islands", iso2: "mh" },
  { dialCode: "+596", name: "Martinique", iso2: "mq" },
  { dialCode: "+222", name: "Mauritania", iso2: "mr" },
  { dialCode: "+230", name: "Mauritius", iso2: "mu" },
  { dialCode: "+52", name: "Mexico", iso2: "mx" },
  { dialCode: "+691", name: "Micronesia", iso2: "fm" },
  { dialCode: "+373", name: "Moldova", iso2: "md" },
  { dialCode: "+377", name: "Monaco", iso2: "mc" },
  { dialCode: "+976", name: "Mongolia", iso2: "mn" },
  { dialCode: "+382", name: "Montenegro", iso2: "me" },
  { dialCode: "+212", name: "Morocco", iso2: "ma" },
  { dialCode: "+258", name: "Mozambique", iso2: "mz" },
  { dialCode: "+95", name: "Myanmar", iso2: "mm" },
  { dialCode: "+264", name: "Namibia", iso2: "na" },
  { dialCode: "+674", name: "Nauru", iso2: "nr" },
  { dialCode: "+977", name: "Nepal", iso2: "np" },
  { dialCode: "+31", name: "Netherlands", iso2: "nl" },
  { dialCode: "+687", name: "New Caledonia", iso2: "nc" },
  { dialCode: "+64", name: "New Zealand", iso2: "nz" },
  { dialCode: "+505", name: "Nicaragua", iso2: "ni" },
  { dialCode: "+227", name: "Niger", iso2: "ne" },
  { dialCode: "+234", name: "Nigeria", iso2: "ng" },
  { dialCode: "+850", name: "North Korea", iso2: "kp" },
  { dialCode: "+47", name: "Norway", iso2: "no" },
  { dialCode: "+968", name: "Oman", iso2: "om" },
  { dialCode: "+92", name: "Pakistan", iso2: "pk" },
  { dialCode: "+680", name: "Palau", iso2: "pw" },
  { dialCode: "+970", name: "Palestine", iso2: "ps" },
  { dialCode: "+507", name: "Panama", iso2: "pa" },
  { dialCode: "+675", name: "Papua New Guinea", iso2: "pg" },
  { dialCode: "+595", name: "Paraguay", iso2: "py" },
  { dialCode: "+51", name: "Peru", iso2: "pe" },
  { dialCode: "+63", name: "Philippines", iso2: "ph" },
  { dialCode: "+48", name: "Poland", iso2: "pl" },
  { dialCode: "+351", name: "Portugal", iso2: "pt" },
  { dialCode: "+1", name: "Puerto Rico", iso2: "pr" },
  { dialCode: "+974", name: "Qatar", iso2: "qa" },
  { dialCode: "+262", name: "Réunion", iso2: "re" },
  { dialCode: "+40", name: "Romania", iso2: "ro" },
  { dialCode: "+7", name: "Russia", iso2: "ru" },
  { dialCode: "+250", name: "Rwanda", iso2: "rw" },
  { dialCode: "+1869", name: "Saint Kitts and Nevis", iso2: "kn" },
  { dialCode: "+1758", name: "Saint Lucia", iso2: "lc" },
  { dialCode: "+1784", name: "Saint Vincent and the Grenadines", iso2: "vc" },
  { dialCode: "+685", name: "Samoa", iso2: "ws" },
  { dialCode: "+378", name: "San Marino", iso2: "sm" },
  { dialCode: "+239", name: "São Tomé and Príncipe", iso2: "st" },
  { dialCode: "+966", name: "Saudi Arabia", iso2: "sa" },
  { dialCode: "+221", name: "Senegal", iso2: "sn" },
  { dialCode: "+381", name: "Serbia", iso2: "rs" },
  { dialCode: "+248", name: "Seychelles", iso2: "sc" },
  { dialCode: "+232", name: "Sierra Leone", iso2: "sl" },
  { dialCode: "+65", name: "Singapore", iso2: "sg" },
  { dialCode: "+421", name: "Slovakia", iso2: "sk" },
  { dialCode: "+386", name: "Slovenia", iso2: "si" },
  { dialCode: "+677", name: "Solomon Islands", iso2: "sb" },
  { dialCode: "+252", name: "Somalia", iso2: "so" },
  { dialCode: "+27", name: "South Africa", iso2: "za" },
  { dialCode: "+82", name: "South Korea", iso2: "kr" },
  { dialCode: "+211", name: "South Sudan", iso2: "ss" },
  { dialCode: "+34", name: "Spain", iso2: "es" },
  { dialCode: "+94", name: "Sri Lanka", iso2: "lk" },
  { dialCode: "+249", name: "Sudan", iso2: "sd" },
  { dialCode: "+597", name: "Suriname", iso2: "sr" },
  { dialCode: "+268", name: "Swaziland", iso2: "sz" },
  { dialCode: "+46", name: "Sweden", iso2: "se" },
  { dialCode: "+41", name: "Switzerland", iso2: "ch" },
  { dialCode: "+963", name: "Syria", iso2: "sy" },
  { dialCode: "+886", name: "Taiwan", iso2: "tw" },
  { dialCode: "+992", name: "Tajikistan", iso2: "tj" },
  { dialCode: "+255", name: "Tanzania", iso2: "tz" },
  { dialCode: "+66", name: "Thailand", iso2: "th" },
  { dialCode: "+670", name: "Timor-Leste", iso2: "tl" },
  { dialCode: "+228", name: "Togo", iso2: "tg" },
  { dialCode: "+676", name: "Tonga", iso2: "to" },
  { dialCode: "+1868", name: "Trinidad and Tobago", iso2: "tt" },
  { dialCode: "+216", name: "Tunisia", iso2: "tn" },
  { dialCode: "+90", name: "Turkey", iso2: "tr" },
  { dialCode: "+993", name: "Turkmenistan", iso2: "tm" },
  { dialCode: "+688", name: "Tuvalu", iso2: "tv" },
  { dialCode: "+256", name: "Uganda", iso2: "ug" },
  { dialCode: "+380", name: "Ukraine", iso2: "ua" },
  { dialCode: "+971", name: "United Arab Emirates", iso2: "ae" },
  { dialCode: "+44", name: "United Kingdom", iso2: "gb" },
  { dialCode: "+1", name: "United States", iso2: "us" },
  { dialCode: "+598", name: "Uruguay", iso2: "uy" },
  { dialCode: "+998", name: "Uzbekistan", iso2: "uz" },
  { dialCode: "+678", name: "Vanuatu", iso2: "vu" },
  { dialCode: "+39", name: "Vatican City", iso2: "va" },
  { dialCode: "+58", name: "Venezuela", iso2: "ve" },
  { dialCode: "+84", name: "Vietnam", iso2: "vn" },
  { dialCode: "+967", name: "Yemen", iso2: "ye" },
  { dialCode: "+260", name: "Zambia", iso2: "zm" },
  { dialCode: "+263", name: "Zimbabwe", iso2: "zw" },
];

// Remove in future
export const HIDE_WIDGETS = [
  "FIRST_CALL_RECORDER",
  "LEAD_QUALIFICATION_SCANNER",
  "REFERRAL_CARD_SCANNER",
];
export const CAMERA_PERMISSION = {
  PENDING: "pending",
  GRANTED: "granted",
  DENIED: "denied",
  NOT_AVAILABLE: "not_available",
  IN_USE: "in_use"
} as const;

export const ALERT_TYPE = {
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
  WARNING: "warning",
} as const;
